import React, { useState, useEffect, useContext} from "react"
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import validator from 'validator';
import {csvFormat} from 'd3-dsv'
import 'moment/locale/fr'
import { v4 as uuidv4 } from 'uuid';
import {
  Box,
  Container,
  Button,
  Hidden,
  TextField,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import AddIcon from '@material-ui/icons/Add';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import AlarmIcon from '@material-ui/icons/Alarm';
import CloseIcon from '@material-ui/icons/Close';
import {
  Box as BoxIcon,
} from 'react-feather';

import PageContentWrapper from "../PageContentWrapper"
import RecruiterUserRows from "./RecruiterUserRows"
import MyModal from "../ui/MyModal"
import AddMultipleCandidats from "../ui/AddMultipleCandidats"

import ScansContext from "../../contexts/ScansContext"
import PopupNotifContext from "../../contexts/PopupNotifContext"

import APIS from "../../utils/APIS"

moment.locale("fr");


const RecruiterViewScan = ({ }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  let { id } = useParams();

  const [dialogAddCandidat, setDialogAddCandidat] = useState(false)
  const [isAddingCandidat, setIsAddingCandidat] = useState(false)
  const [emailAddCandidat, setEmailAddCandidat] = useState("")
  useEffect(() => {
    setEmailAddCandidat("")
    setIsAddingCandidat(false)
  }, [dialogAddCandidat])

  const [dialogAddMultipleCandidats, setDialogAddMultipleCandidats] = useState(false)

  const [actScan, setActScan] = useState(null)
  const { isLoaded, scans, colorByFamily, getScans } = useContext(ScansContext)

  const { addPopupNotif } = useContext(PopupNotifContext)

  useEffect(() => {
    if (isLoaded === true) {
      let find = scans.find((el) => el.id === parseInt(id))
      let isPlayable = find?.playable
      let content = find?.module
      if (find && isPlayable && content) {
        setActScan(find)
      } else {
        navigate('/')
        setActScan(null)
      }
    }
  }, [isLoaded, actScan, id, scans])

  const exportResults = () => {
    let toExport = []
    let filename = 'Export candidats Scan '+actScan?.name+ ', ' + moment().format('DD/MM/YYYY') + ' ' + moment().format('HH')+'h'+moment().format('mm')
    const renameKeys = (keysMap, objs) => {
      for (let i=0; i<objs.length;i++) {
        let obj = objs[i]
        objs[i] = Object.keys(obj).reduce(
        (acc, key) => ({
            ...acc,
            ...{ [keysMap[key] || key]: obj[key] }
        }),
        {})
      }
      return objs
    }

    let fieldsExport = [
      "Nom",
      "Email",
      "Compte activé",
      "Statut",
      "Progression",
      "Résultat",
    ]

    let fieldsRename = {
      name : "Nom",
      email : "Email",
      actived : "Compte activé",
      status : "Statut",
      progression : "Progression",
      result : "Résultat",
    }

    actScan?.userIDs?.forEach((user) => {
      let resultForThisUser = actScan?.userResults?.find((el) => el.userID === user.userID)

      let progress = 0
      let statut = "Pas commencé"
      let result = "En attente"
      if (resultForThisUser) {
        progress = resultForThisUser?.progress
        if (resultForThisUser?.progress === 100 && resultForThisUser?.isDone === true) {
          statut = "Terminé"
          if (resultForThisUser?.validationResult === true) {
            result = "Compatible"
          } else if (resultForThisUser?.validationResult === false) {
            result = "Incompatible"
          }
        } else {
          statut = "En cours"
        }
      }

      toExport.push({
        name : user?.userName,
        email : user?.userEmail,
        actived : user?.actived === "true" ? "Oui" : "Non",
        status : statut,
        progression : progress,
        result : result
      })

    })

    let rename = renameKeys(fieldsRename, toExport);
    let csv = csvFormat(rename, fieldsExport);
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
    link.setAttribute('download', filename+'.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }


  return (
    <PageContentWrapper
      title={actScan?.name}
      buttonTitle="Inviter"
      buttonIcon={<AddIcon/>}
      buttonOnClick={() => {
        setDialogAddCandidat(true)
      }}
      buttonDisabled={actScan !== null ? actScan.isOpen === false ? true : false : true}
      onglets={[{
        title: "Aperçu",
        icon : <BoxIcon size="16px"/>,
        onClick : () => {

        },
      }]}
    >
      {actScan !== null &&
        <Box sx={{flex:1, maxWidth:"100%", overflow:"hidden", display:"flex", flexDirection:"column", gap:["15px", "25px", "35px"]}}>
          <Box sx={{display:"flex", gap:["10px", "15px", "20px"]}}>
            <Box
              sx={{
                flex:1,
                background:"white",
                border:"1px solid #E7E7E7",
                padding:["15px", "20px", "25px"],
                display:"flex",
                flexDirection:"column",
                cursor:"pointer",
                gap:["3px", "7px", "10px"],
                userSelect:"none",
                "&:hover" : {
                  border:"1px solid black",
                }
              }}
              onClick={() => {
                navigate("/app/scan/"+actScan?.id+"/invitees")
              }}
            >
              <Box sx={{
                fontSize:["14px", "14px", "18px"],
                color:"text.primary",
                fontWeight:400
              }}>
                Invités
              </Box>
              <Box sx={{
                fontSize:["22px", "36px", "50px"],
                color:"text.black",
                fontWeight:500
              }}>
                {actScan?.invitedCounter}
              </Box>
            </Box>
            <Box
              sx={{
                flex:1,
                background:"white",
                border:"1px solid #E7E7E7",
                padding:["15px", "20px", "25px"],
                display:"flex",
                flexDirection:"column",
                cursor:"pointer",
                gap:["3px", "7px", "10px"],
                userSelect:"none",
                "&:hover" : {
                  border:"1px solid black",
                }
              }}
              onClick={() => {
                navigate("/app/scan/"+actScan?.id+"/completed")
              }}
            >
              <Box sx={{
                fontSize:["14px", "14px", "18px"],
                color:"text.primary",
                fontWeight:400
              }}>
                Complétés
              </Box>
              <Box sx={{
                fontSize:["22px", "36px", "50px"],
                color:"text.black",
                fontWeight:500
              }}>
                {actScan?.completedCounter}
              </Box>
            </Box>
            <Box
              sx={{
                flex:1,
                background:"white",
                border:"1px solid #E7E7E7",
                padding:["15px", "20px", "25px"],
                display:"flex",
                flexDirection:"column",
                cursor:"pointer",
                gap:["3px", "7px", "10px"],
                userSelect:"none",
                "&:hover" : {
                  border:"1px solid black",
                }
              }}
              onClick={() => {
                navigate("/app/scan/"+actScan?.id+"/passed")
              }}
            >
              <Box sx={{
                fontSize:["14px", "14px", "18px"],
                color:"text.primary",
                fontWeight:400
              }}>
                Réussis
              </Box>
              <Box sx={{
                fontSize:["22px", "36px", "50px"],
                color:"text.black",
                fontWeight:500
              }}>
                {actScan?.passedCounter}
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              background:"white",
              border:"1px solid #E7E7E7",
              display:"flex",
              justifyContent:"space-between",
              gap:"15px",
            }}
          >
            <Box sx={{
              padding:["15px", "20px", "25px"],
              display:"flex",
              gap:"15px",
              flexDirection:["column", "column", "row"],
              maxWidth:"100%",
            }}>
              <Box sx={{flex:0.45}}>
                <Box sx={{
                  textTransform:"capitalize",
                  fontSize:["22px", "28px", "32px"],
                  fontWeight:500,
                  color:"text.black",
                  whiteSpace:"nowrap",
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                }}>
                  {actScan?.module?.name}
                </Box>
                <Box sx={{marginTop:"15px", display:"flex", flexWrap:"wrap", gap:"7px",}}>
                  {actScan?.module?.softSkills?.filter((el) => el.value === "oui").map((skill, index) => {
                    let color = colorByFamily?.find((el) => el.family === skill?.family)
                    return (
                      <Box
                        key={index}
                        sx={{
                          fontSize:["10px", "11px", "12px"],
                          fontWeight:500,
                          padding:["7px", "8px", "9px"],
                          flexShrink:0,
                          background : color?.bg,
                          color: color?.text,
                          border: `1px solid ${color?.border}`,
                          textTransform:"uppercase",
                          userSelect:"none",
                        }}
                      >
                        {skill?.key}
                      </Box>
                    )
                  })}
                </Box>
              </Box>
              <Box sx={{
                fontSize:["12px", "15px", "16px"],
                fontWeight:400,
                color:"text.primary",
                padding:["0px", "0px", "30px"],
                flex:0.55,
              }}>
                {actScan?.module?.description}
                <Box sx={{
                  marginTop:"15px",
                  fontSize:["14px", "14px", "14px"],
                  display:"flex",
                  alignItems:"center",
                  gap:"5px",
                }}>
                  <AlarmIcon />{actScan?.module?.timing} minutes pour terminer
                </Box>

              </Box>
            </Box>
            <Box sx={{background:"#FED64A", width:["0px", "230px", "300px"], minWidth:["0px", "230px", "300px"], height:"100%"}} />
          </Box>

          <Box
            sx={{
              display:["none", "flex", "flex"],
              justifyContent:"flex-start",
              gap:"25px",
              height:["0px", "50px", "60px"],
            }}
          >
            <Button
              variant="contained"
              size={"medium"}
              startIcon={<AddIcon/>}
              onClick={() => {
                setDialogAddCandidat(true)
              }}
              disabled={actScan?.isOpen === false ? true : false}
              sx={{
                fontSize:["0px", "18px", "24px"],
                lineHeight:["0px", "18px", "24px"],
                fontWeight:500,
                color:"black",
                background:"white",
                border:"1px solid #E7E7E7",
                "& svg":{
                  width:["0px", "18px", "23px"],
                  height:["0px", "18px", "23px"],
                },
                "&:hover":{
                  color:"black",
                  background:"white",
                  border:"1px solid #E7E7E7",
                },
              }}
            >
              Ajouter candidat
            </Button>

            <Button
              variant="contained"
              size={"medium"}
              startIcon={<AddIcon/>}
              onClick={() => {
                setDialogAddMultipleCandidats(true)
              }}
              disabled={actScan?.isOpen === false ? true : false}
              sx={{
                fontSize:["0px", "18px", "24px"],
                lineHeight:["0px", "18px", "24px"],
                fontWeight:500,
                color:"black",
                background:"white",
                border:"1px solid #E7E7E7",
                "& svg":{
                  width:["0px", "18px", "23px"],
                  height:["0px", "18px", "23px"],
                },
                "&:hover":{
                  color:"black",
                  background:"white",
                  border:"1px solid #E7E7E7",
                },
              }}
            >
              Importer candidats
            </Button>

            <Button
              variant="contained"
              size={"medium"}
              startIcon={<ArrowDownwardIcon/>}
              disabled={actScan?.userIDs?.length > 0 ? false : true}
              onClick={() => {
                exportResults()
              }}
              sx={{
                fontSize:["0px", "18px", "24px"],
                lineHeight:["0px", "18px", "24px"],
                fontWeight:500,
                color:"black",
                background:"white",
                border:"1px solid #E7E7E7",
                "& svg":{
                  width:["0px", "18px", "23px"],
                  height:["0px", "18px", "23px"],
                },
                "&:hover":{
                  color:"black",
                  background:"white",
                  border:"1px solid #E7E7E7",
                },
              }}
            >
              Exporter résultats
            </Button>
          </Box>

          <Box
            sx={{
              display:"flex",
              flexDirection:"column",
              gap:"20px",
            }}
          >
            <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
              <Box sx={{
                color:"text.black",
                fontWeight:500,
                fontSize:["22px", "26px", "32px"],
              }}>
                Candidats
              </Box>
              <Hidden smUp>
                <Button
                  variant="text"
                  size={"medium"}
                  startIcon={<ArrowDownwardIcon/>}
                  onClick={() => {
                    exportResults()
                  }}
                  disabled={actScan?.userIDs?.length > 0 ? false : true}
                  sx={{
                    fontSize:"15px",
                    fontWeight:500,
                  }}
                >
                  Exporter
                </Button>
              </Hidden>
            </Box>
            {actScan?.userIDs?.length > 0 ? (
              <RecruiterUserRows
                actScan={actScan}
                userList={actScan?.userIDs}
              />
            ) : (
              <Box sx={{
                background:"white",
                border:"1px solid #E7E7E7",
                py : ["35px", "35px", "35px"],
                px : ["20px", "20px", "20px"],
                display:"flex",
                flexDirection:"column",
                alignItems:"center",
                gap:"20px"
              }}>
                <Box sx={{
                  fontSize:["24px", "32px", "32px"],
                  fontWeight : 500,
                  textAlign:"center",
                }}>Invitez vos candidats</Box>
                <Box sx={{
                  fontSize:"15px",
                  fontWeight : 500,
                  color:"text.primary",
                  maxWidth:"500px",
                  textAlign:"center",
                }}>
                  Invitez un candidat à réaliser son scan pour analyser l’adéquation entre son profil et le poste.
                </Box>
                <Box sx={{display:"flex", flexWrap:"wrap", gap:"15px", justifyContent:"center"}}>
                  <Button
                    color="primary"
                    size="large"
                    variant="contained"
                    endIcon={<AddIcon/>}
                    disabled={actScan?.isOpen === false ? true : false}
                    onClick={() => {
                      setDialogAddCandidat(true)
                    }}
                  >
                    Inviter un candidat
                  </Button>
                  <Button
                    color="primary"
                    size="large"
                    variant="contained"
                    endIcon={<AddIcon/>}
                    disabled={actScan?.isOpen === false ? true : false}
                    onClick={() => {
                      setDialogAddMultipleCandidats(true)
                    }}
                  >
                    Télécharger
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      }


      {dialogAddCandidat &&
        <MyModal
          isOpen={dialogAddCandidat}
          maxWidth="sm"
          onClose={() => {
            setDialogAddCandidat(false)
          }}
        >
          <Hidden smUp>
            <Box sx={{
              paddingLeft:"5px",
              paddingRight:"5px",
              paddingTop:"10px",
              display:"flex",
              overflow:"hidden",
              maxWidth:"100%",
              gap:"5px",
            }}>
              <Button
                variant="text"
                size={"medium"}
                onClick={() => { }}
                sx={{
                  padding:"0px 4px",
                  minWidth:0,
                  visibility:"hidden",
                }}
              >
                <ChevronLeftIcon/>
              </Button>
              <Box sx={{
                flexGrow:1,
                fontSize:"16px",
                color:"text.primary",
                fontWeight:400,
                textAlign:"center",
                textOverflow:"ellipsis",
                overflow:"hidden",
                whiteSpace:"nowrap",
                useSelect:"none",
                textTransform:"capitalize",
              }}>
                {actScan?.name}
              </Box>
              <Button
                variant="text"
                size={"medium"}
                onClick={() => {
                  setDialogAddCandidat(false)
                }}
                sx={{
                  padding:"0px 4px",
                  minWidth:0,
                }}
              >
                <CloseIcon/>
              </Button>
            </Box>
          </Hidden>
          <Box sx={{
            display:"flex",
            flexDirection:"column",
            height:"100%",
            padding:["25px", "30px", "40px"],
            gap:"20px",
          }}>
            <Box sx={{
              textAlign:"center",
              color:"text.black",
              fontWeight:500,
              fontSize:["22px", "36px", "36px"],
            }}>
              Inviter un candidat
            </Box>
            <Box sx={{
              textAlign:"center",
              color:"text.primary",
              fontWeight:400,
              fontSize:["15px", "18px", "18px"],
            }}>
              Le candidat recevra une invitation à cette adresse électronique.
            </Box>
            <Box sx={{flexGrow:1, display:"flex", justifyContent:"center"}}>
              <TextField
                fullWidth
                sx={{
                  maxWidth:"420px",
                  "& .MuiInputBase-root": {
                    background:mediaQueryUpSm ? "#FAF8F6" : "white",
                  },
                }}
                label="Adresse Email"
                margin="normal"
                name="email"
                inputProps={{ maxLength: 50 }}
                onChange={(e) => {setEmailAddCandidat(e.target.value)}}
                type="email"
                value={emailAddCandidat}
                variant="outlined"
              />
            </Box>
            <Box sx={{display:"flex", flexDirection:"column", gap:"5px", alignItems:"center"}}>
              <Button
                color="primary"
                size="large"
                fullWidth
                sx={{
                  maxWidth:"420px",
                }}
                variant="contained"
                endIcon={<ChevronRightIcon/>}
                onClick={() => {
                  let closeDate = moment(actScan?.plan?.plan[0]?.closeDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
                  setIsAddingCandidat(true)
                  APIS.addCandidat({email : emailAddCandidat.trim(), groupeID : actScan?.id, closeDate : closeDate}).then((result) => {
                    if (result?.message === "addCandidat") {
                      addPopupNotif({
                        uuid : uuidv4(),
                        text : emailAddCandidat+" a bien été invité !",
                        type : "confirmation",
                        removeAfter:5000,
                      })
                      setDialogAddCandidat(false)
                      getScans()
                    } else if (result?.message === "emailExist") {
                      addPopupNotif({
                        uuid : uuidv4(),
                        text : emailAddCandidat+" existe déjà !",
                        type : "error",
                        removeAfter:5000,
                      })
                      setDialogAddCandidat(false)
                    } else {
                      addPopupNotif({
                        uuid : uuidv4(),
                        text : "Erreur !",
                        type : "error",
                        removeAfter:5000,
                      })
                      setDialogAddCandidat(false)
                    }
                  })
                }}
                disabled={isAddingCandidat === true ? true : !validator.isEmail(emailAddCandidat)}
              >
                Envoyer l'invitation
              </Button>
              <Button
                variant="text"
                size={"medium"}
                fullWidth
                onClick={() => {
                  setDialogAddCandidat(false)
                  setDialogAddMultipleCandidats(true)
                }}
                sx={{
                  fontSize:"16px",
                  fontWeight:500,
                  maxWidth:"420px",
                }}
              >
                Télécharger une liste
              </Button>
            </Box>
          </Box>
        </MyModal>
      }

      {dialogAddMultipleCandidats &&
        <MyModal
          isOpen={dialogAddMultipleCandidats}
          maxWidth="sm"
          onClose={() => {
            setDialogAddMultipleCandidats(false)
          }}
        >
          <AddMultipleCandidats
            actScan={actScan}
            onClose={() => {
              setDialogAddMultipleCandidats(false)
            }}
          />
        </MyModal>
      }
    </PageContentWrapper>
  )
};

export default RecruiterViewScan;
